import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "info-card detailed-card" }
const _hoisted_2 = { class: "card-title" }
const _hoisted_3 = { class: "info-block" }
const _hoisted_4 = { class: "center" }
const _hoisted_5 = { class: "dates" }
const _hoisted_6 = { class: "date info-with-label has-mobile-only" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "status-label mobile-portrait info-label" }, " Release: ", -1)
const _hoisted_8 = { class: "release" }
const _hoisted_9 = { class: "date info-with-label has-mobile-only" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "status-label mobile-portrait info-label" }, " Due: ", -1)
const _hoisted_11 = { class: "due" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.cohort), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.publishDateShort), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.dueDateShort), 1)
        ])
      ])
    ])
  ]))
}